import gql from 'graphql-tag';

export const GET_USER_BASIC_INFO = gql`
  query getUserBasicInfo($userId: String!) {
    customer(customerId: $userId) {
      name
      email
      customerId
      designation
      access
      isActive
      employeesCount
      createdAt
    }
  }
`;

export const CREATE_USER = gql`
  mutation addHR(
    $accountId: String!
    $name: String!
    $designation: String!
    $email: EmailAddress!
    $access: String!
    $isActive: Boolean!
  ) {
    addHR(
      accountId: $accountId
      name: $name
      email: $email
      designation: $designation
      access: $access
      isActive: $isActive
    ) {
      customerId
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateHR(
    $accountId: String!
    $userId: String!
    $name: String!
    $access: String!
    $designation: String!
    $isActive: Boolean!
  ) {
    updateHR(
      accountId: $accountId
      customerId: $userId
      name: $name
      designation: $designation
      access: $access
      isActive: $isActive
    ) {
      customerId
    }
  }
`;
